import { render, staticRenderFns } from "./Small-Header.vue?vue&type=template&id=022b85f8&scoped=true&"
import script from "./Small-Header.vue?vue&type=script&lang=js&"
export * from "./Small-Header.vue?vue&type=script&lang=js&"
import style0 from "./Small-Header.vue?vue&type=style&index=0&id=022b85f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b85f8",
  null
  
)

export default component.exports